// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.language-selector {
  position: absolute;
  bottom: 0;
  left: 128px;
  width: 88px;
  height: 51px;
  padding-left: 40px;
  background-color: #444444;
  box-sizing: unset;
}
.language-selector span {
  color: #ffffff;
  font-family: Montserrat-Regular;
  font-size: 15px;
}
.language-selector:hover {
  cursor: pointer;
}
.language-selector:hover span {
  color: #685925;
}
`, "",{"version":3,"sources":["webpack://./node_modules/proceduralsystem-clientcomponents/components/internationalisation/internationalisation.component.less"],"names":[],"mappings":"AAEA;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,iBAAA;AADJ;AAPA;EAWQ,cAAA;EACA,+BAAA;EACA,eAAA;AADR;AAII;EACI,eAAA;AAFR;AACI;EAIQ,cAAA;AAFZ","sourcesContent":["@import (reference) '../../styles/variables.less';\n\n.language-selector {\n    position: absolute;\n    bottom: 0;\n    left: 128px;\n    width: 88px;\n    height: 51px;\n    padding-left: 40px;\n    background-color: @secondary-90;\n    box-sizing: unset;\n\n    span {\n        color: @white;\n        font-family: Montserrat-Regular;\n        font-size: 15px;\n    }\n\n    &:hover {\n        cursor: pointer;\n\n        span {\n            color: @primary-hover;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
